// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__c25DK","image":"Showcase_image__6Mq1Y","backBtn":"Showcase_backBtn__UeWdp","nextBtn":"Showcase_nextBtn__ICdmi","App":"Showcase_App__nd0E+"};